import { Persona, Scene } from "@soulmachines/smwebsdk";
import {
  ContentCard,
  HeadlineTypes,
  PlaintextTypes,
  CharacterSelectionTypes,
  ImgCtaButtonsTypes,
  BulletListTypes,
  PersonaTranscriptTypes,
  UserTranscriptTypes,
  RedirectTypes,
  SurveryTypes,
  TipsTypes,
  SliderTypes,
  ImgTypes,
  ImgDescTypes,
} from "./ContentCard";

export enum UserActionType {
  CONNECT_SCENE = "CONNECT_SCENE",
  START_VIDEO = "START_VIDEO",
  TOGGLE_MUTE = "TOGGLE_MUTE",
  SET_VIDEO_DIMENSIONS = "SET_VIDEO_DIMENSIONS",
  TOGGLE_PAUSE = "TOGGLE_PAUSE",
  ADD_PERSONA_MESSAGE = "ADD_PERSONA_MESSAGE",
  DISCONNECT = "DISCONNECT",
  SET_INTERMEDIATE_USER_UTTERANCE = "SET_INTERMEDIATE_USER_UTTERANCE",
  ADD_CONVERSATION_MESSAGE = "ADD_CONVERSATION_MESSAGE",
  SET_ERROR = "SET_ERROR",
  CLEAR_ERROR = "CLEAR_ERROR",
  SET_TABLET_LANDSCAPE = "SET_TABLET_LANDSCAPE",
  UPDATE_SCENE = "UPDATE_SCENE",
  MODIFY_CONTENT_CARDS = "MODIFY_CONTENT_CARDS",
  SET_ACTIVE_CARDS = "SET_ACTIVE_CARDS",
  TOGGLE_CONVERSATION_TRANSCRIPT = "TOGGLE_CONVERSATION_TRANSCRIPT",
  SKIP = "SKIP",
  CLEAR_CONTENT_CARDS = "CLEAR_CONTENT_CARDS",
  ADD_ROTATION_CONTENT_CARDS = "ADD_ROTATION_CONTENT_CARDS",
}

export type UserAction =
  | {
      type: UserActionType.UPDATE_SCENE;
      payload: { scene: Scene };
    }
  | { type: UserActionType.CONNECT_SCENE }
  | { type: UserActionType.START_VIDEO }
  | { type: UserActionType.TOGGLE_MUTE }
  | {
      type: UserActionType.SET_VIDEO_DIMENSIONS;
      payload: { videoHeight: number; videoWidth: number };
    }
  | { type: UserActionType.TOGGLE_PAUSE }
  | {
      type: UserActionType.ADD_CONVERSATION_MESSAGE;
      payload: {
        source: string;
        text: { id: string } | string;
      };
    }
  | {
      type: UserActionType.SET_INTERMEDIATE_USER_UTTERANCE;
      payload: { text: string };
    }
  | {
      type: UserActionType.SET_ERROR;
      payload: { errorType: string };
    }
  | { type: UserActionType.CLEAR_ERROR }
  | {
      type: UserActionType.SET_TABLET_LANDSCAPE;
      payload: { tabletLandscape: boolean };
    }
  | {
      type: UserActionType.MODIFY_CONTENT_CARDS;
      payload: {
        contentCards: {
          [key: string]:
            | HeadlineTypes
            | PlaintextTypes
            | CharacterSelectionTypes
            | BulletListTypes
            | TipsTypes
            | SliderTypes
            | ImgTypes
            | ImgDescTypes
            | ImgCtaButtonsTypes;
        };
      };
    }
  | { type: UserActionType.TOGGLE_CONVERSATION_TRANSCRIPT }
  | { type: UserActionType.SKIP }
  | { type: UserActionType.CLEAR_CONTENT_CARDS }
  | {
      type: UserActionType.ADD_ROTATION_CONTENT_CARDS;
      payload: { rotation: string[] };
    }
  | { type: UserActionType.DISCONNECT };

export interface InitalStateProps {
  connected: boolean;
  error: boolean;
  errorType: null | {
    headerText: string;
    bodyText: string;
    error?: string;
    buttonText: {
      one: string;
      two: string;
    };
  };
  scene: Scene | null;
  persona: Persona | null;
  videoPlaying: boolean;
  videoHeight: number;
  videoWidth: number;
  mute: boolean;
  pause: boolean;
  contentCards: {
    [key: string]:
      | HeadlineTypes
      | PlaintextTypes
      | CharacterSelectionTypes
      | BulletListTypes
      | PersonaTranscriptTypes
      | UserTranscriptTypes
      | RedirectTypes
      | SurveryTypes
      | TipsTypes
      | SliderTypes
      | ImgTypes
      | ImgDescTypes
      | ImgCtaButtonsTypes;
  };
  contentCardThisturn: Array<string>;
  transcript: Array<ContentCard>;
  shownCardsThisTurn: Array<ContentCard>;
  intermediateUserUtterance: string;
  tabletLandscape: boolean;
  conversationTranscript: boolean;
  skipClicked:boolean
}
